import React, { useEffect, useState } from "react";
import { withSnackbar } from "../../../components/atoms/SpSnackBar";
import Organization from "./Organization";
import { getProfessionalById } from "../../../models/actions/Professionals";

const OrganizationDetails = (props) => {
  const [professional, setProfessional] = useState({});

  useEffect(async () => {
    const professionalTemp = await getProfessionalById();
    setProfessional(professionalTemp);
  }, []);

  return <Organization props={props} selectedProfessional={professional?.id} />;
};
export default withSnackbar(OrganizationDetails);
